@if (routerEvents$ | async) {

}
<div class="st-side-bar flex flex-column align-items-center">
  <div
    class="show-hide-toggle"
    [ngClass]="{ 'show-hide-toggle-active': isExpandedMenu() }"
  >
    <button title="Expand menu" (click)="expandMenu()"><em class="icon-list"></em></button>
  </div>
  <div
    class="st-side-bar-content flex-1 flex flex-column align-items-center gap-12px"
  >
    @if (homeButton().routeUrl.length) {
      <a
        [pTooltip]="tooltipContent"
        [tooltipStyleClass]="'icon-btn-tooltip'"
        class="home-button no-underline"
        [routerLink]="homeButton().routeUrl"
      >
        <button
        title="Home"
          [ngClass]="{ 'home-active': isHomeButtonActive() }"
          (click)="goToHome(homeButton().routeUrl)"
        >
          <em [class]="homeButton().iconClass"></em>
        </button>
      </a>

      <div class="sidebar-tooltip">
      <ng-template #tooltipContent>
        <div class="sidebar-tooltip-content">
          <span class="label-medium-medium">
            {{ homeButton().title }}
          </span>
        </div>
      </ng-template>
      </div>

      <div class="side-divider"></div>
    }
    <div
      class="inner-section flex flex-column align-items-center gap-12px flex-1"
    >
      <div
        class="navigation-section flex flex-column align-items-center gap-12px"
      >
        @for (nav of navigationList(); track $index) {
          <st-icon-button [navigationItem]="nav"></st-icon-button>
        }
      </div>
      <div class="side-divider"></div>
      @if (tools().length) {
        <div class="apps-section">
          <st-apps-tools-menu [tools]="tools()"></st-apps-tools-menu>
        </div>
      }
      <div
        class="profile-setting-section flex flex-column align-items-center gap-12px mt-auto"
      >
        <a
          class="profile-section cursor-pointer"
          (click)="toggleMenu($event, profileMenue)"
          [title]="profile().userName"
        >
          <img
            [src]="profile().profileImg"
            alt=""
          />
        </a>

        <p-menu
          #profileMenue
          [model]="dropDownItems"
          [popup]="true"
          appendTo="body"
        />
      </div>
    </div>
  </div>
</div>
